/* The mockup's `.qr`: a 176px tile; the SVG draws its own white quiet zone (see TotpQr.tsx). */
.qr {
  inline-size: 176px;
  block-size: 176px;
  overflow: hidden;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-card);
}

.qr svg {
  display: block;
  inline-size: 100%;
  block-size: 100%;
}
